/* eslint-disable */
import {
  createStyles,
  List,
  ListItem,
  ListItemText,
  Theme,
  withStyles,
} from "@material-ui/core";
import { Checkbox } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Component } from "react";
import { connect } from "react-redux";

import {
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
} from "../../../../utils/store/actions/users.actions";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    accordion: {
      borderRadius: "10px",
      boxShadow: "none",
    },
  });

class PopUpProperties extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  handleChangeProperty(e: any, prop: any) {
    this.props.edit_Properties({
      key: prop.key,
      value: e.target
        ? e.target.checked !== undefined
          ? e.target.checked
          : e.target.value
        : e.value,
    });
  }
  
  render() {
    const { classes, t } = this.props;
    return (
         <Accordion className={classes.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: "#AE0064" }} />}
              aria-controls="panel2a-content"
              id="modules"
            >
              <Typography className={classes.heading}>{"Pop ups"}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List
                style={{ maxHeight: 400, overflow: "auto" }}
                className={classes.root}
              >
                {(this.props.Users?.get_properties || [])
                  ?.filter((property: any) => property.key.includes("MODAL"))
                  ?.map((property: any) => (
                    <ListItem key={property.id}>
                      <Checkbox
                        value={property.value}
                        style={{ marginTop: "10px", marginRight: "5px" }}
                        defaultIsChecked={
                          property.value === "true" ? true : false
                        }
                        onChange={(e: any) => {
                          this.handleChangeProperty(e, property);
                        }}
                        edge="end"
                        inputProps={{
                          "aria-labelledby": `checkbox-list-label-${property}`,
                        }}
                      />
                      <ListItemText
                        id={property.key}
                        primary={t(property.key)}
                      />
                    </ListItem>
                  ))}
              </List>
            </AccordionDetails>
          </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PopUpProperties)));
